"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalEmitter = void 0;
class UniversalEmitter {
    constructor() {
        this.listeners = {};
        // Alias for removeListener if needed, but 'off' is standard enough
    }
    on(event, listener) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(listener);
        return this;
    }
    off(event, listener) {
        if (!this.listeners[event])
            return this;
        this.listeners[event] = this.listeners[event].filter(l => l !== listener);
        return this;
    }
    once(event, listener) {
        const wrapper = (...args) => {
            this.off(event, wrapper);
            listener(...args);
        };
        return this.on(event, wrapper);
    }
    emit(event, ...args) {
        if (!this.listeners[event])
            return false;
        this.listeners[event].forEach(listener => listener(...args));
        return true;
    }
}
exports.UniversalEmitter = UniversalEmitter;
